import React, { useEffect, useState } from "react";

import "./sidebar.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import DashboardSVG from "../../../assets/icons/sidebar/dashboardSVG";
import ManufacturerSvg from "../../../assets/icons/sidebar/manufacturerSvg";
import DistributorSvg from "../../../assets/icons/sidebar/distributorSvg";
import CustomersSvg from "../../../assets/icons/sidebar/customersSvg";
import SuperUserSvg from "../../../assets/icons/sidebar/superUserSvg";
import FaqSvg from "../../../assets/icons/sidebar/FaqSvg";
import LogoutModal from "../modals/logoutModal";
import { useDispatch } from "react-redux";
import { logout } from "../../../redux/actions/authActions";
import SettingsSvg from "../../../assets/icons/sidebar/settingsSvg";
import SuccessPopup from "../../popups/SuccessPopup";
import ErrorPopup from "../../popups/ErrorPopup";
import SupportSvg from "../../../assets/icons/sidebar/supportSvg";
import arrRig from "../../../assets/icons/sidebar/arrow-right-line.svg";
import SidebarComponent from "./sidebarComponent";
import AnalyticsSvg from "../../../assets/icons/sidebar/AnalyticsSvg";
import FfTrainingSvg from "../../../assets/icons/sidebar/ffTraining";
import SidebarIconComponent from "./sidebarIconComponent";
import InvoiceVerifySvg from "../../../assets/icons/sidebar/invoiceVerifySvg";

const SideBar = ({ open, setOpen }) => {
  const navigate = useNavigate();

  const [logoutShow, setLogoutShow] = useState(false);
  const dispatch = useDispatch();
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [showSuccessMsg, setShowSuccessMsg] = useState();
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState();
  const [userPermissionList, setUserPermissionList] = useState(null); // PERMISSION START
  const user_type = localStorage.getItem("userType");

  useEffect(() => {
    if (user_type === "super_admin") {
      const permissionData = JSON.parse(localStorage.getItem("permissions"));
      console.log(
        permissionData?.map((item) => item?.module_name),
        "permission"
      );

      setUserPermissionList(permissionData?.map((item) => item?.module_name));
    }
  }, [user_type]); // PERMISSION END

  const logoutHandler = () => {
    dispatch(logout(logoutSuccess, logoutError));
  };

  const timeOutFnc = () => {
    setShowSuccessPopup(false);
    navigate("/");
  };

  const logoutSuccess = (data) => {
    console.log(data);
    setShowSuccessPopup(true);
    const str = data.data.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setShowSuccessMsg(str_modify);
    setTimeout(timeOutFnc, 2000);
  };

  const closeErrorPopup = () => {
    setShowErrorPopup(false);
  };

  const logoutError = (err) => {
    console.log(err);
    const str = err.data.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setShowErrorMsg(str_modify);
    setShowErrorPopup(true);
  };

  const location = useLocation();
  const url = location.pathname;
  const pathArray = url.split("/");
  const activePath = "/" + pathArray[1];

  const sidebarConfig = [
    {
      label: "Dashboard",
      path: "/dashboard",
      icon: DashboardSVG,
      visible: () => true,
    },
    {
      label: "Analytics",
      path: "/analytics",
      icon: AnalyticsSvg,
      visible: () => localStorage.getItem("userType") !== "super_admin",
    },
    {
      label: "Manufacturers",
      path: "/manufacturer",
      icon: ManufacturerSvg,
      visible: ({ user_type = "", userPermissionList = [] } = {}) =>
        user_type !== "super_admin" ||
        userPermissionList.includes("Manufacturer"),

      subItems: [
        {
          label: "subscribed manufacturers",
          path: "/manufacturer/subscibe-list",
        },
        {
          label: "premium manufacturers",
          path: "/manufacturer/premium-list",
        },
      ],
    },
    {
      label: "Distributors",
      path: "/distributors",
      icon: DistributorSvg,
      visible: ({ user_type = "", userPermissionList = [] } = {}) =>
        user_type !== "super_admin" ||
        userPermissionList.includes("Distributors"),

      subItems: [
        {
          label: "ONBOARDED distributors",
          path: "/distributors/distributor",
        },
        {
          label: "ONBOARDING distributors",
          path: "/distributors/onboard-distributor",
        },
      ],
    },
    {
      label: "Customers",
      path: "/customers",
      icon: CustomersSvg,
      visible: ({ user_type = "", userPermissionList = [] } = {}) =>
        user_type !== "super_admin" || userPermissionList.includes("Customers"),

      subItems: [
        {
          label: "Onboarded Customers",
          path: "/customers/customer",
        },
        {
          label: "Onboarding Requests",
          path: "/customers/request",
        },
        {
          label: "Change Distributor Requests",
          path: "/customers/distributor-request",
        },
      ],
    },
    {
      label: "SUPER USERS",
      path: "/super-user",
      icon: SuperUserSvg,
      visible: () => localStorage.getItem("userType") !== "super_admin",

      subItems: [
        {
          label: "users",
          path: "/super-user/user",
        },
        {
          label: "roles",
          path: "/super-user/role",
        },
      ],
    },
    {
      label: "invoice verification",
      path: "/invoice-verification",
      icon: InvoiceVerifySvg,
      visible: ({ user_type = "", userPermissionList = [] } = {}) =>
        user_type !== "super_admin" || userPermissionList.includes("Customers"),

      subItems: [
        {
          label: "Ai Verified Invoices",
          path: "/invoice-verification/ai-verified-invoices",
        },
        {
          label: "Verified Invoices",
          path: "/invoice-verification/verified-invoices",
        },
        {
          label: "Ai Flaged Invoices",
          path: "/invoice-verification/ai-flagged-invoices",
        },
        {
          label: "Pending Invoices",
          path: "/invoice-verification/pending-invoices",
        },
        {
          label: "Rejected Invoices",
          path: "/invoice-verification/rejected-invoices",
        },
      ],
    },
    {
      label: "FAQ's",
      path: "/faq",
      icon: FaqSvg,
      visible: () => localStorage.getItem("userType") !== "super_admin",
    },
    {
      label: "Settings",
      path: "/settings",
      icon: SettingsSvg,
      visible: ({ user_type = "", userPermissionList = [] } = {}) =>
        user_type !== "super_admin" || userPermissionList.includes("Settings"),

      subItems: [
        {
          label: "state",
          path: "/settings/state",
        },
        {
          label: "District",
          path: "/settings/district",
        },
        {
          label: "City",
          path: "/settings/city",
        },
        {
          label: "Pincode",
          path: "/settings/pincode",
        },
        {
          label: "Invoice template",
          path: "/settings/invoice-template",
        },
        {
          label: "Reasons For Rejection",
          path: "/settings/reason-for-rejection",
        },
        {
          label: "Privacy Policy",
          path: "/settings/privacy-policy/view",
        },
        {
          label: "Terms & Condition",
          path: "/settings/terms-condition/view",
        },
        {
          label: "Advertisement",
          path: "/settings/advertisement",
        },
      ],
    },
    {
      label: "Support",
      path: "/support",
      icon: SupportSvg,
      visible: ({ user_type = "", userPermissionList = [] } = {}) =>
        user_type !== "super_admin" || userPermissionList.includes("Support"),

      subItems: [
        {
          label: "Customer Verification",
          path: "/support/customer-verification",
        },
      ],
    },
    {
      label: "Field Force Training",
      path: "/ff-training",
      icon: FfTrainingSvg,
      visible: ({ user_type = "", userPermissionList = [] } = {}) =>
        user_type !== "super_admin" ||
        userPermissionList.includes("Field Force Training"),

      subItems: [
        {
          label: "Field Force Chapters",
          path: "/ff-training/chapters",
        },
        {
          label: "Field Force Q/A",
          path: "/ff-training/qa",
        },
      ],
    },
  ];

  return (
    <>
      <div
        className={`${
          open
            ? "d-block mainlayout_sidebar_small_display"
            : "mainlayout_sidebar_display d-none d-lg-block"
        }   mainlayout_sidebar_container position-relative`}
      >
        <div className="d-none d-lg-block" onClick={() => setOpen(!open)}>
          <div className="position-absolute arrow-container py-2 cursor_pointer">
            <div className={open ? "arrow-open-icon" : "arrow-icon me-1"}>
              <img src={arrRig} alt={"right"} />
            </div>
          </div>
        </div>
        {open ? (
          <SidebarIconComponent
            userPermissionList={userPermissionList}
            sidebarConfig={sidebarConfig}
          />
        ) : (
          <div style={{ maxWidth: "295px", overflow: "hidden" }}>
            <SidebarComponent
              open={open}
              setOpen={setOpen}
              userPermissionList={userPermissionList}
              sidebarConfig={sidebarConfig}
            />
          </div>
        )}
      </div>

      <LogoutModal
        logoutShow={logoutShow}
        handleLogoutClose={() => setLogoutShow(false)}
        logoutFunc={logoutHandler}
      />
      <SuccessPopup show={showSuccessPopup} title={showSuccessMsg} />
      <ErrorPopup
        show={showErrorPopup}
        title={showErrorMsg}
        handleClose={closeErrorPopup}
      />
    </>
  );
};

export default SideBar;
